import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GrowlerService } from './service/growler.service';
import { AlertComponent } from '../alert/alert.component';

@Component({
  selector: 'lt-growler',
  imports: [CommonModule, AlertComponent],
  templateUrl: './growler.component.html',
  styleUrls: ['./growler.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GrowlerComponent {
  readonly service = inject(GrowlerService);

  readonly growlerConfigs = this.service.growlerConfigs;

  dismissAt(id: string): void {
    this.service.dismissAt(id);
  }

  onHoverState(isActive: boolean): void {
    this.service.setHovering(isActive);
  }

  onFocusState(isActive: boolean): void {
    this.service.setHasFocus(isActive);
  }
}
